import _regeneratorRuntime from 'babel-runtime/regenerator';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
// import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import SliderProfiles from './SliderProfiles';
import { withTranslation } from 'react-i18next';
// import Select from 'react-select';
// import Switch from '@material-ui/core/Switch';
// import FormGroup from '@material-ui/core/FormGroup';
// import FormControlLabel from '@material-ui/core/FormControlLabel';


import API, { graphqlOperation } from '@aws-amplify/api';
import PubSub from '@aws-amplify/pubsub';
import { updateUsers, createUsers } from '../graphqlUsers/mutations';
import config from '../graphqlUsers/aws-exports';
// import { getUsers } from '../graphqlUsers/queries';
import gql from "graphql-tag";
import { AWSAppSyncClient } from "aws-appsync";
API.configure(config); // Configure Amplify
PubSub.configure();

var client = new AWSAppSyncClient({
    url: config.aws_appsync_graphqlEndpoint,
    region: config.aws_appsync_region,
    auth: {
        type: config.aws_appsync_authenticationType,
        apiKey: config.aws_appsync_apiKey
    },
    offlineConfig: {
        callback: function callback(err, succ) {
            if (err) {
                var mutation = err.mutation;


                console.warn('ERROR for ' + mutation, err);
            } else {
                var _mutation = succ.mutation;


                console.info('SUCCESS for ' + _mutation, succ);
            }
        }
    }
});

var buttonStyled = {
    width: '40px',
    height: '40px',
    borderRadius: '2px',
    position: 'absolute',
    zIndex: '6',
    border: 'none',
    cursor: 'pointer',
    top: '10px',
    left: "calc(100% - 105px)",
    boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px",
    background: '#fff'
};

export var iconOptionsMap = function (_React$Component) {
    _inherits(iconOptionsMap, _React$Component);

    function iconOptionsMap(props) {
        _classCallCheck(this, iconOptionsMap);

        var _this = _possibleConstructorReturn(this, (iconOptionsMap.__proto__ || Object.getPrototypeOf(iconOptionsMap)).call(this, props));

        _this.handleClick = function () {
            var containerOptions = document.getElementById("containerOptions");
            if (!_this.state.edit) {
                if (containerOptions.classList.contains('displayNone') && containerOptions.style.display === "none") {
                    containerOptions.style.display = "block";
                    document.addEventListener('click', _this.handleOutsideClick, false);
                } else if (containerOptions.classList.contains('displayNone') && containerOptions.style.display === "") {
                    containerOptions.style.display = "block";
                    document.addEventListener('click', _this.handleOutsideClick, false);
                } else if (containerOptions.style.display === "block" && !_this.state.edit) {
                    document.removeEventListener('click', _this.handleOutsideClick, false);
                    containerOptions.style.display = "none";
                }
            }
        };

        _this.handleOutsideClick = function (e) {
            if (_this.myRef.current.contains(e.target)) {
                return;
            }
            _this.handleClick();
        };

        _this.handleChange = function (event) {
            _this.setState({ value: event.target.value });

            _this.state.profiles.forEach(function (item) {
                if (item.title === event.target.value) {
                    document.getElementById("nameProfile").selectedIndex = 0;
                    return _this.props.chargeProfile(item.options, item.center, item.isTrafficLayerShown, item.zoom);
                }
            });
        };

        _this.handleChangeSelect = function (event) {
            if (event.target.value === "Mapa") {
                _this.props.viewStandardMap();
            } else {
                _this.props.viewSatelliteMap();
            }
            _this.setState({ valueSelect: event.target.value });
        };

        _this.addProfile1 = function () {
            var now = new Date();

            var newProfile = {
                id: now.getMilliseconds(),
                title: "",
                edit: true,
                delete: false,
                options: {
                    mapTypeId: _this.props.map.options.mapTypeId,
                    gestureHandling: _this.props.map.options.gestureHandling,
                    disableDefaultUI: _this.props.map.options.disableDefaultUI,
                    mapTypeControl: _this.props.map.options.mapTypeControl

                },
                zoom: _this.props.map.options.zoom,
                center: _this.props.map.center,
                isTrafficLayerShown: _this.props.map.isTrafficLayerShown
            };
            document.getElementById("line").style.marginTop = "41px";
            _this.setState({
                profiles: [].concat(_toConsumableArray(_this.state.profiles), [newProfile]),
                edit: !_this.state.edit,
                value: "",
                oldValue: _this.state.value
            });
        };

        _this.edit = function (id) {

            document.getElementById("line").style.marginTop = "41px";

            _this.state.profiles.forEach(function (profile) {
                if (profile.id === id) {
                    profile.edit = true;
                }
            });
            _this.setState({ edit: !_this.state.edit });
        };

        _this.save = function (id, input) {
            var add = false;
            // let actualMap = localStorage.getItem("actualMap");
            // actualMap = JSON.parse(actualMap);
            // console.log(actualMap);
            _this.state.profiles.map(function (profile) {
                if (_this.state.edit && !profile.delete) {
                    if (profile.id === id) {
                        profile.title = input.current.value;
                        profile.center = { lat: _this.props.actualMap.center.lat(), lng: _this.props.actualMap.center.lng() };
                        profile.isTrafficLayerShown = _this.props.map.isTrafficLayerShown;

                        profile.edit = false;
                        profile.firstCreate = false;
                        profile.options = {
                            mapTypeId: _this.props.map.options.mapTypeId,
                            gestureHandling: _this.props.map.options.gestureHandling,
                            disableDefaultUI: _this.props.map.options.disableDefaultUI,
                            mapTypeControl: _this.props.map.options.mapTypeControl,
                            zoom: _this.props.actualMap.zoom
                        };
                    }

                    add = true;
                }
                if (_this.state.edit && profile.delete) {
                    add = false;
                    var newProfile = _this.state.profiles.filter(function (profile) {
                        return profile.id !== id;
                    });
                    _this.setState({ profiles: newProfile, edit: !_this.state.edit });
                    _this.saveProfileOnDB(newProfile);
                }
                document.getElementById("line").style.marginTop = "2px";

                return profile;
            });

            if (add) {
                _this.setState({
                    edit: false,
                    value: input.current.value
                });
                _this.saveProfileOnDB(_this.state.profiles);

                add = false;
            }
        };

        _this.cancel = function (id) {
            var copyProfiles = [].concat(_toConsumableArray(_this.state.profiles));
            var copyValue = [].concat(_toConsumableArray(_this.state.value));
            _this.state.profiles.forEach(function (profile) {
                if (profile.id === id) {
                    if (!profile.edit && profile.delete) {
                        var newProfile = _this.state.profiles.filter(function (profile) {
                            return profile.id !== id;
                        });
                        _this.setState({ profiles: newProfile, edit: false, value: _this.state.profiles[0].title });
                    }
                    if (profile.edit && profile.delete && !profile.firstCreate || profile.edit) {
                        profile.delete = false;
                        profile.edit = false;
                        profile.firstCreate = false;
                        var newProfiles = copyProfiles.splice(copyProfiles.length - 1, 1);;
                        // copyProfiles = copyProfiles.splice(copyProfiles.length-1,1);
                        _this.setState({ edit: false, profiles: copyProfiles, value: _this.state.oldValue });
                    }
                }
                document.getElementById("line").style.marginTop = "2px";
            });
        };

        _this.deleteProfile = function (id) {

            if (_this.state.profiles !== undefined) {
                if (_this.state.profiles.length === 1) {
                    return;
                }
            }

            var updateProfile = _this.state.profiles.map(function (profile) {
                if (profile.id === id) {
                    profile.delete = !profile.delete;
                    profile.edit = true;
                }
                if (profile.edit && profile.delete) {
                    var newProfile = _this.state.profiles.filter(function (profile) {
                        return profile.id !== id;
                    });

                    _this.setState({ profiles: newProfile, value: _this.state.profiles[0].title });
                    _this.saveProfileOnDB(newProfile);
                }
                return profile;
            });

            // this.setState({
            //     edit: false
            // })
        };

        _this.viewSatelliteMap = function () {
            var actualMap = _this.props.actualMap;

            actualMap.mapTypeId = "satellite";
            _this.setState({
                firstCreate: false
            });
        };

        _this.myRef = React.createRef();
        // this.textInput = React.createRef();
        _this.state = {
            profiles: _this.props.profiles,
            userFromDataBase: '',
            selectedOption: null,
            edit: false,
            delete: false,
            firstCreate: false,
            value: _this.props.value !== undefined ? _this.props.value : "",
            newProfileToDB: [],
            userDataInfo: _this.props.email,
            createProfile: false,
            valueSelect: _this.props.map.options.mapTypeId === "roadmap" ? props.t("map.sidebar.configurationMapProfiles.selectOptionTypeMap.map") : props.t("map.sidebar.configurationMapProfiles.selectOptionTypeMap.satellite"),
            oldValue: ""
        };
        return _this;
    }

    // componentDidMount() {
    //     console.log("componentDidMount - optionMap");
    //     this.getData();


    // }

    // async getData() {
    //     console.log("getData - optionMap");
    //     const userData = await API.graphql(graphqlOperation(getUsers, { email: this.props.email }))
    //     if (userData.data.getUsers === null) {
    //         this.setState({
    //             createProfile: true
    //         });
    //         return;
    //     } else {
    //         this.setState({
    //             createProfile: false
    //         });
    //     }
    //     this.setState({
    //         userFromDataBase: { ...this.state.userFromDataBase, userData }
    //     })
    //     this.getProfile();
    // }

    _createClass(iconOptionsMap, [{
        key: 'saveProfileOnDB',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(profiles) {
                var newArray, email, todoDetail, result, _result;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                newArray = [];


                                profiles.map(function (profile) {
                                    newArray.push(JSON.stringify({
                                        "trafficLayer": profile.isTrafficLayerShown,
                                        "mapControls": profile.options.disableDefaultUI,
                                        "latitude": profile.center.lat,
                                        "mapType": profile.options.mapTypeId,
                                        "gestureHandling": profile.options.gestureHandling,
                                        "zoom": profile.options.zoom,
                                        "title": profile.title,
                                        "longitude": profile.center.lng
                                    }));
                                    return profile;
                                });

                                email = "";

                                if (this.props.email !== undefined | this.props.email !== null) {
                                    email = this.props.email;
                                } else {
                                    email = localStorage.getItem("email");
                                }
                                todoDetail = {
                                    email: email, mapOptions: newArray
                                };

                                if (!this.state.createProfile) {
                                    _context.next = 13;
                                    break;
                                }

                                _context.next = 8;
                                return client.mutate({
                                    mutation: gql(createUsers),
                                    variables: {
                                        input: todoDetail
                                    }
                                });

                            case 8:
                                result = _context.sent;

                                this.setState({
                                    createProfile: false
                                });
                                console.warn(result);
                                _context.next = 17;
                                break;

                            case 13:
                                _context.next = 15;
                                return client.mutate({
                                    mutation: gql(updateUsers),
                                    variables: {
                                        input: todoDetail
                                    }
                                });

                            case 15:
                                _result = _context.sent;

                                console.warn(_result);

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function saveProfileOnDB(_x) {
                return _ref.apply(this, arguments);
            }

            return saveProfileOnDB;
        }()

        // getProfile = () => {
        //     console.log("getProfile - optionMap")
        //     let newArray = [];
        //     this.state.userFromDataBase.userData.data.getUsers.mapOptions.map((user, i) => {
        //         let now = new Date();
        //         newArray.push(
        //             {
        //                 id: now.getTime() + i,
        //                 title: JSON.parse(user).title,
        //                 edit: false,
        //                 delete: false,
        //                 options: {
        //                     mapTypeId: JSON.parse(user).mapType,
        //                     gestureHandling: JSON.parse(user).gestureHandling,
        //                     disableDefaultUI: (JSON.parse(user).mapControls),
        //                     mapTypeControl: (JSON.parse(user).mapControls),
        //                     zoom: parseInt(JSON.parse(user).zoom, 10),
        //                 },
        //                 center: { lat: parseFloat(JSON.parse(user).latitude), lng: parseFloat(JSON.parse(user).longitude) },
        //                 isTrafficLayerShown: JSON.parse(user).trafficLayer
        //             }
        //         )
        //         if (i === 0) {
        //             this.props.chargeProfile(newArray[0].options, newArray[0].center, newArray[0].isTrafficLayerShown)
        //         }
        //         return user;
        //     });

        //     this.setState({
        //         profiles: newArray,
        //         value: newArray[0].title
        //     });
        // }

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var t = this.props.t;
            // console.log("render optionMap")

            return React.createElement(
                'div',
                { ref: this.myRef },
                React.createElement(
                    'button',
                    { id: 'btn-options', onClick: this.handleClick, style: buttonStyled },
                    React.createElement('img', { alt: "img", style: { width: "20px", height: "26px", fill: "red" }, src: 'https://staticcontent.inelcan.com/img/gear-option.svg' })
                ),
                React.createElement(
                    'div',
                    { id: 'containerOptions', className: 'containerOptions displayNone' },
                    React.createElement(
                        'h5',
                        { className: '' },
                        t("map.sidebar.configurationMapProfiles.title")
                    ),
                    React.createElement(
                        'p',
                        { className: 'lineBottom', style: { marginLeft: "4px", marginTop: "20px" } },
                        React.createElement(
                            'b',
                            null,
                            t("map.sidebar.configurationMapProfiles.profile"),
                            ':'
                        ),
                        ' ',
                        this.state.value
                    ),
                    React.createElement('div', { className: 'line-select' }),
                    this.state.profiles.length > 0 && React.createElement(
                        'select',
                        { value: 'Seleccione un perfil', onChange: this.handleChange, id: 'nameProfile', style: { display: this.state.edit ? 'none' : 'inline-block' && this.state.delete ? 'none' : 'inline-block' } },
                        React.createElement(
                            'option',
                            { value: 'Seleccione un perfil' },
                            t("map.sidebar.configurationMapProfiles.selectProfilePlaceHolder.selectProfile")
                        ),
                        this.state.profiles.map(function (item) {
                            return React.createElement(
                                'option',
                                { value: item.title, key: item.id },
                                item.title
                            );
                        })
                    ),
                    React.createElement('div', { id: 'line', className: 'line-select' }),
                    React.createElement(
                        'div',
                        { style: { marginBottom: "15px" } },
                        React.createElement(
                            'select',
                            { value: this.state.valueSelect, onChange: this.handleChangeSelect },
                            React.createElement(
                                'option',
                                { value: 'Mapa' },
                                t("map.sidebar.configurationMapProfiles.selectOptionTypeMap.map")
                            ),
                            React.createElement(
                                'option',
                                { value: 'Sat\xE9lite' },
                                t("map.sidebar.configurationMapProfiles.selectOptionTypeMap.satellite")
                            )
                        ),
                        React.createElement('div', { className: 'line-select' })
                    ),
                    this.state.profiles.length === 0 && React.createElement(SliderProfiles, {
                        profile: "",
                        key: 0,
                        save: this.save,
                        deleteProfile: this.deleteProfile,
                        edit: this.edit,
                        cancel: this.cancel,
                        chargeProfile: this.props.chargeProfile,
                        map: this.props.map,
                        addProfile11: this.addProfile1,
                        trafficLayerShow: this.props.trafficLayerShow,
                        mapMobile: this.props.mapMobile,
                        toggleUi: this.props.toggleUi,
                        changeGroupMarkerVehicle: this.props.changeGroupMarkerVehicle

                    }),
                    this.state.profiles.map(function (item) {
                        return React.createElement(
                            'div',
                            { key: item.id,
                                style: { display: _this2.state.value === item.title ? "inline-block" : "none" }
                            },
                            React.createElement(SliderProfiles, {
                                profile: item,
                                key: item.id,
                                save: _this2.save,
                                deleteProfile: _this2.deleteProfile,
                                edit: _this2.edit,
                                cancel: _this2.cancel,
                                chargeProfile: _this2.props.chargeProfile,
                                map: _this2.props.map,
                                addProfile11: _this2.addProfile1,
                                trafficLayerShow: _this2.props.trafficLayerShow,
                                mapMobile: _this2.props.mapMobile,
                                toggleUi: _this2.props.toggleUi,
                                changeGroupMarkerVehicle: _this2.props.changeGroupMarkerVehicle

                            })
                        );
                    })
                )
            );
        }
    }]);

    return iconOptionsMap;
}(React.Component);

export default withTranslation()(iconOptionsMap);